import { REQUEST_STATUS_LABELS } from '../../services/creationRequestService';

const STATUS_STYLES = {
  brouillon: 'bg-gray-100 text-gray-600',
  nouvelle: 'bg-blue-100 text-blue-700',
  creation_en_cours: 'bg-amber-100 text-amber-700',
  verification: 'bg-violet-100 text-violet-700',
  site_pret: 'bg-cyan-100 text-cyan-700',
  site_publié: 'bg-green-100 text-green-700',
  email_envoye: 'bg-green-100 text-green-700'
};

const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${STATUS_STYLES[status] || 'bg-gray-100 text-gray-600'}`}>
    {REQUEST_STATUS_LABELS[status] || status}
  </span>
);

export default StatusBadge;
